import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';

import { MtnaSearchBoxModule } from '@mtna/lib-ui';

import { RdsVariableListComponent } from './variable-list.component';

@NgModule({
  imports: [CommonModule, ScrollingModule, MatListModule, MatIconModule, MatProgressBarModule, MtnaSearchBoxModule, RouterModule],
  declarations: [RdsVariableListComponent],
  exports: [RdsVariableListComponent]
})
export class RdsVariableListModule {}

export * from './variable-list.component';
